import Herosection from "./herosection/Herosection";
import About from "./about/About";
import Navbar from "./navbar/Navbar";
import Application from "./application/Application";
import Benefits from "./benefits/Benefits";
import Footer from "./footer/Footer";
import Transform from "./transform/Transform";
import Arinnovation from "./arinnovation/Arinnovation";
import Feedback from "./feedback/Feedback";
import Services from "./services/Services";
import Faq from "./faq/Faq";

import "./ARVR.css";

function ARVR() {
  return (
    <div id="arvr">
      <Navbar />
      <Herosection />
      <About />
      <Transform />
      <Application />
      <Arinnovation />
      <Feedback />
      <Services />
      <Faq />
      {/* <Benefits /> */}
      <Footer />
    </div>
  );
}

export default ARVR;
